import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import Logo from '../assets/logo.png';
import { Link as ScrollLink } from 'react-scroll';

const sections = [
  { id: 'process', label: 'Cómo trabajamos' },
  { id: 'portfolio', label: 'Portafolio' },
  { id: 'services', label: 'Servicios' },
  { id: 'about', label: 'Nosotros' },
  { id: 'contact', label: 'Contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AppBar
      position="sticky"
      elevation={scrolled ? 4 : 0}
      sx={{
        bgcolor: scrolled ? 'rgba(8,58,148,0.97)' : '#083a94',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        transition: 'box-shadow 0.3s',
      }}
    >
      <Toolbar sx={{ py: 0.5 }}>
        <ScrollLink to="hero" smooth duration={500} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
          <img src={Logo} alt="EFFSOS Logo" style={{ height: 38 }} />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              background: 'linear-gradient(90deg, #ffffff 0%, #38BDF8 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.01em',
            }}
          >
            Effsos
          </Typography>
        </ScrollLink>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
          {sections.map(({ id, label }) => (
            <ScrollLink key={id} to={id} smooth duration={500} offset={-70} spy activeClass="nav-active" style={{ textDecoration: 'none' }}>
              <Button
                color="inherit"
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '0.92rem',
                  color: 'rgba(255,255,255,0.85)',
                  borderRadius: 2,
                  px: 1.5,
                  '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                {label}
              </Button>
            </ScrollLink>
          ))}

          <ScrollLink to="contact" smooth duration={500} offset={-70} style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              sx={{
                ml: 1,
                bgcolor: '#38BDF8',
                color: '#083a94',
                fontWeight: 700,
                textTransform: 'none',
                fontSize: '0.92rem',
                borderRadius: 2,
                px: 2.5,
                '&:hover': { bgcolor: '#7DD3FC' },
              }}
            >
              Hablemos
            </Button>
          </ScrollLink>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
